import React from "react";

import { TaskCardFooterStatus } from "./TaskCardFooterStatus";
import { IssueApi } from "api/issuesApi";
import { TaskCardFooterAssignees } from "./TaskCardFooterAssignees";
import { TaskCardItemsList } from "./TaskCardItemsList";

interface TaskCardProps {
  issue: IssueApi;
  onClick?: () => void;
}
export const TaskCard = ({ issue, onClick }: TaskCardProps) => {
  return (
    <div
      onClick={onClick}
      className="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 p-4 cursor-pointer  hover:bg-gray-100 transition ease-in-out duration-200"
    >
      <div className="mb-3">
        <h2 className="font-semibold text-slate-800 dark:text-slate-100 mb-1">{issue.title}</h2>
        <div>
          <div className="text-sm">
            utworzone przez{" "}
            <a className="font-medium text-slate-800 hover:underline dark:text-slate-200" href="#0">
              {issue.createdBy.email}
            </a>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <TaskCardFooterAssignees assignees={issue.assignees} />
        <TaskCardFooterStatus dueDate={issue.dueDate} commentsNo={0} link={issue.link} />
      </div>
      <TaskCardItemsList items={issue.issueItems} />
    </div>
  );
};
